var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev_stat"},[_c('ContentSection',{attrs:{"title":'设备统计',"mainStyle":{ borderLeftStyle: 'solid' },"position":'right'}},[_c('div',{staticClass:"dev_main"},[_c('div',{staticClass:"my_chart"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }